import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {AgentModel} from "../models/agent.model";

export const AgentsChannelActions = createActionGroup({
  source: '[Agent/Channel]',
  events: {
    subscribe: props<{ids?: string[]}>(),
    unsubscribe: emptyProps(),
    unsubscribeSuccess: emptyProps(),
    notificationReceived: props<{ notification: AgentModel }>(),
  },
});

export const AgentsAPiActions = createActionGroup({
  source: '[Agent/API]',
  events: {

    //Get infinite scroll Agents
    getInfiniteScrollAgents: props<{ params?: any, isSubscribeToChannel?: boolean }>(),
    getInfiniteScrollAgentsSuccess: props<{ agents: AgentModel[], cursor?: string, isSubscribeToChannel?: boolean }>(),
    getInfiniteScrollAgentsFailure: props<{ error: any }>(),

    //Get agents
    getAgents: props<{ params?: any, isSubscribeToChannel?: boolean }>(),
    getAgentsSuccess: props<{ agents: AgentModel[], isSubscribeToChannel?: boolean }>(),
    getAgentsFailure: props<{ error: any }>(),

    //Get agent
    getAgent: props<{ id: string, isSubscribeToChannel?: boolean }>(),
    getAgentSuccess: props<{ agent: AgentModel, isSubscribeToChannel?: boolean }>(),
    getAgentFailure: props<{ error: any }>(),

    //Create Agent
    createAgent: props<{ agent: AgentModel }>(),
    createAgentSuccess: props<{ agent: AgentModel }>(),
    createAgentFailure: props<{ error: any }>(),

    //Update Agent
    updateAgent: props<{ id: string, agent: AgentModel }>(),
    updateAgentSuccess: props<{ agent: AgentModel }>(),
    updateAgentFailure: props<{ error: any }>(),

    //Delete Agent
    deleteAgent: props<{ id: string, shouldMask?: boolean }>(),
    deleteAgentSuccess: props<{ agent: AgentModel }>(),
    deleteAgentFailure: props<{ error: any }>()

  },
});

export const AgentsActions = createActionGroup({
  source: '[Agent]',
  events: {
    setInfiniteScrollAgentIds: props<{ agentIds: string[], isAppendFirst?: boolean }>(),
    removeAll: emptyProps(),
    clearStore: emptyProps()
  }
});
